var allowSubmit = false;
var target = null;
var title = '';
var body1 = '';
var body2 = '';
var confirm = '';

function allowSubmitBtn(target) {
  allowSubmit = true;
  target.click();
}

function displayTexts(target) {
  title = target.dataset.title;
  body1 = target.dataset.body1;
  body2 = target.dataset.body2;
  confirm = target.dataset.confirm;
  $('#modal-title').text(title);
  $('#modal-body1').text(body1);
  $('#modal-body2').text(body2);
  $('#allow-action-modal').text(confirm);
}

document.addEventListener('turbo:load', () => {
  if ($('.open-confirm-modal').length) {
    $('.open-confirm-modal').on('click', function(event) {
      if (!allowSubmit) {
        event.preventDefault();
        target = event.currentTarget;
        displayTexts(target);
        $('#modal-buttons').removeClass('d-none');
        $('#dataConfirm').modal('show');
        $('#allow-action-modal').on('click', function() {
          allowSubmitBtn(target);
        });
      } else {
        allowSubmit = false;
      }
    });
  }
})
